import { Paper, Typography, TextField, Box, Checkbox, MenuItem, Select } from "@mui/material";
import SymbolField from "../Util/SymbolField";

const DICE_EFFECTS = [
    { key: "", label: "None" },
    { key: "BoostCount", label: "Add Boost" },
    { key: "AddSetbackCount", label: "Add Setback" },
    { key: "SetbackSubCount", label: "Remove Setback" },
    { key: "AdvantageCount", label: "Add Advantage" },
    { key: "ThreatCount", label: "Add Threat" },
    { key: "SuccessCount", label: "Add Success" },
    { key: "FailureCount", label: "Add Failure" },
];

const DEFENSE_TYPES = [
    { key: "", label: "None" },
    { key: "melee", label: "Melee Defense" },
    { key: "ranged", label: "Ranged Defense" },
];

const FLAGS = [
    { key: "IsQuality", label: "Is Quality" },
    { key: "IsActiveQuality", label: "Active Quality" },
    { key: "IsBase", label: "Base Quality" },
    { key: "IsBoolean", label: "Boolean (no rating)" },
];

const QualityEdit = ({ editedItem, index, appFiles, setAppFiles }) => {
    const handleEdit = (newItem) => {
        let newFiles = { ...appFiles };
        let newCat = JSON.parse(appFiles["qualities"]);
        newCat[index] = newItem;
        newFiles["qualities"] = JSON.stringify(newCat);
        setAppFiles(newFiles);
        localStorage.setItem('appFiles', JSON.stringify(newFiles));
    };

    const setField = (key, value) => {
        const next = { ...editedItem };
        if (value === undefined || value === "" || value === false) { delete next[key]; }
        else { next[key] = value; }
        handleEdit(next);
    };

    return (
        <Paper sx={{ padding: "10px" }}>
            <TextField
                fullWidth
                label="Name"
                value={editedItem?.Name || ""}
                onChange={(e) => handleEdit({ ...editedItem, Name: e.target.value })}
                sx={{ marginTop: "10px" }}
            />
            <SymbolField
                label="Description"
                sx={{ width: "100%", marginTop: "10px" }}
                value={editedItem?.Description || ""}
                onChange={(e) => handleEdit({ ...editedItem, Description: e.target.value })}
            />
            <TextField
                label="Type"
                value={editedItem?.Type || ""}
                onChange={(e) => handleEdit({ ...editedItem, Type: e.target.value })}
                sx={{ marginTop: "10px", maxWidth: "220px" }}
            />

            <Typography variant="h6" sx={{ marginTop: "15px" }}>Mechanical Effect (on a weapon that has it):</Typography>
            <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "15px", marginTop: "5px" }}>
                <Box>
                    <Typography variant="caption">Dice Pool Effect (× rating)</Typography>
                    <Select
                        fullWidth
                        value={editedItem?.DiceEffect || ""}
                        onChange={(e) => setField("DiceEffect", e.target.value)}
                        displayEmpty
                        sx={{ minWidth: "200px" }}
                    >
                        {DICE_EFFECTS.map((d) => (<MenuItem key={d.key} value={d.key}>{d.label}</MenuItem>))}
                    </Select>
                </Box>
                <Box>
                    <Typography variant="caption">Adds Defense (× rating)</Typography>
                    <Select
                        fullWidth
                        value={editedItem?.DefenseType || ""}
                        onChange={(e) => setField("DefenseType", e.target.value)}
                        displayEmpty
                        sx={{ minWidth: "180px" }}
                    >
                        {DEFENSE_TYPES.map((d) => (<MenuItem key={d.key} value={d.key}>{d.label}</MenuItem>))}
                    </Select>
                </Box>
            </Box>

            <Box sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: "20px", marginTop: "15px" }}>
                {FLAGS.map((f) => (
                    <Box key={f.key} sx={{ display: "flex", alignItems: "center" }}>
                        <Typography>{f.label}</Typography>
                        <Checkbox
                            checked={editedItem?.[f.key] === "true"}
                            onChange={(e) => setField(f.key, e.target.checked ? "true" : false)}
                        />
                    </Box>
                ))}
            </Box>
        </Paper>
    );
};

export default QualityEdit;
